import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Carousel } from 'primeng/carousel';
import { DashboardService } from '../Dashboad.service';
import { Router } from '@angular/router';
import { event } from 'jquery';

@Component({
  selector: 'app-team-learnings',
  templateUrl: './team-learnings.component.html',
  styleUrls: ['./team-learnings.component.css']
})
export class TeamLearningsComponent implements OnInit{
  userId :number
  myTeamCourseCount:any;
  pageNo:number = 1;
  pageSize:number = 4;
  viewTeamData:boolean=false;
  toottipText : string= 'Statistics for courses on team learning';
  @ViewChild('carousel') carousel: Carousel;
  @ViewChild('carousel1') carousel1: Carousel;
  @ViewChild('carousel2') carousel2: Carousel;
  @ViewChild('carousel3') carousel3: Carousel;



  // currentCarouselItem: number = 3;
  carousel1Index: number;
  carousel2Index: number;
  carousel3Index: number;

  constructor(private DashboardService : DashboardService,private router:Router){}
  ngOnInit(): void {
    this.userId = parseInt(localStorage.getItem('EmpCareerUserID'))
    this.carousel1Index = 0;
    this.carousel2Index = 0;
    this.carousel3Index = 0;
    this.getMyTeamCourseCount();
  }

  navigateForward(event:any,carousel: Carousel, index:number) {
    if (index < carousel.value?.length - 1) {
      carousel.navForward(event);
      if (carousel === this.carousel1) {
        this.carousel1Index++;
      } else if (carousel === this.carousel2) {
        this.carousel2Index++;
      } else if (carousel === this.carousel3) {
        this.carousel3Index++;
      }
    }

  }

  navigateBackward(event:any, carousel: Carousel, index:number) {
    if (index > 0) {
      carousel.navBackward(event);
      if (carousel === this.carousel1) {
        this.carousel1Index--;
      } else if (carousel === this.carousel2) {
        this.carousel2Index--;
      } else if (carousel === this.carousel3) {
        this.carousel3Index--;
      }
    }
  }

  isForwardDisabled(carousel: Carousel, index: number): boolean {
    return index >= carousel?.value?.length - 1;
  }

  isBackwardDisabled(index: number): boolean {
    return index <= 0;
  }

  getMyTeamCourseCount() {
      this.DashboardService.getMyTeamCourseCount({"userId": this.userId,}).subscribe((res:any) => {
        this.myTeamCourseCount = res;
      });
  }

  getViewData()
  {
    this.viewTeamData=!this.viewTeamData;
  }
  teamCourseDetailsNavigate()
  {
      this.router.navigate(['Home/Dashboard/Team Program Details'])
  }
}
